import {Injectable} from '@angular/core';
import {Headers, Http, RequestOptions, Response} from '@angular/http';
import {Observable} from 'rxjs';
import {FTA, Operacao, Layout, InstalacaoProduto, Cliente, Servico, ItemConfiguracao} from '../../model/catalogo';
import {GlobalService} from '../global.service';
import {UtilApi} from './util.api';
import {userAutorizador} from '../../model/usuario';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../../environments/environment';

@Injectable()
export class CatalogoApiService {

    constructor(public http: HttpClient, public globalService: GlobalService) {
    }

    public criaEditaFta(codigo: number, versao: number, fta: FTA): Observable<any> {

        let url = this.globalService.getConfiguracao().api_catalogo + '/fta/' + codigo + '/' + versao;
        let data = JSON.stringify(fta);

        return this.http.put(url, data, {headers: {'Content-Type': 'application/json; charset=utf-8'}});
    }

    public migrarFta(codigo: number, versao: number, fta: FTA, ambiente: string, tokenString: string): Observable<any> {
        let endpointAmbiente = '';
        if (ambiente != '') {
            switch (ambiente) {
                case 'DES':
                    endpointAmbiente = environment.configDesenv.api_catalogo;
                    break;
                case 'HMG':
                    endpointAmbiente = environment.configHm.api_catalogo;
                    break;
                case 'PRD':
                    endpointAmbiente = environment.configProd.api_catalogo;
                    break;
            }
        }

        let url = endpointAmbiente + '/fta/' + codigo + '/' + versao;
        let data = JSON.stringify(fta);
        let headers = new HttpHeaders();
        headers = headers.set('Authorization', `Bearer ${tokenString}`);
        return this.http.put(url, data, {headers: headers});
    }

    public criaEditaOperacao(codigo: number, versao: number, operacao: Operacao): Observable<any> {
        let url = this.globalService.getConfiguracao().api_catalogo + '/operacao/' + codigo + '/' + versao;
        let data = JSON.stringify(operacao);

        return this.http.put(url, data, {headers: {'Content-Type': 'application/json; charset=utf-8'}});
    }

    public editarConteudoPadraoDeParametroEntrada(nomeOperacao: string, nomeParametro: string, conteudoPadrao: string): Observable<any> {
        let url = this.globalService.getConfiguracao().api_catalogo + '/operacao/conteudoPadraoDeParametroEntrada/' + nomeOperacao + '/' + nomeParametro;
        let data = JSON.stringify({conteudoPadrao});
        return this.http.put(url, data, {headers: {'Content-Type': 'application/json; charset=utf-8'}});
    }

    public removerConteudoPadraoDeParametroEntrada(nomeOperacao: string, nomeParametro: string, conteudoPadrao: string): Observable<any> {
        let url = this.globalService.getConfiguracao().api_catalogo + '/operacao/conteudoPadraoDeParametroEntrada/' + nomeOperacao + '/' + nomeParametro + '?conteudoPadrao=' + conteudoPadrao;
        let data = JSON.stringify({conteudoPadrao});

        return this.http.request('delete', url, {
            body: data,
            headers: {'Content-Type': 'application/json; charset=utf-8'}
        });
        // return this.http.delete(url, { headers: { 'Content-Type': 'application/json; charset=utf-8'} });
    }

    public criaEditaUsuario(codigo: number, versao: number, usuario: userAutorizador): Observable<any> {
        let url = this.globalService.getConfiguracao().api_autorizador + '/usuario/' + codigo + '/' + versao;
        let data = JSON.stringify(usuario);

        return this.http.put(url, data, {headers: {'Content-Type': 'application/json; charset=utf-8'}});
    }

    public criaEditaLayout(codigo: number, versao: number, layout: Layout): Observable<any> {
        let url = this.globalService.getConfiguracao().api_catalogo + '/layout/' + codigo + '/' + versao;
        let data = JSON.stringify(layout);
        return this.http.put(url, data, {headers: {'Content-Type': 'application/json; charset=utf-8'}});
    }

    public criaEditaInstalacaoProduto(codigo: number, versao: number, instalacaoProduto: InstalacaoProduto): Observable<any> {
        let url = this.globalService.getConfiguracao().api_catalogo + '/instalacaoProduto/' + codigo + '/' + versao;
        let data = JSON.stringify(instalacaoProduto);

        return this.http.put(url, data, {headers: {'Content-Type': 'application/json; charset=utf-8'}});
    }

    public removeInstalacaoProduto(codigo: number, versao: number): Observable<any> {
        let url = this.globalService.getConfiguracao().api_catalogo + '/instalacaoProduto/deleta' + '/' + codigo + '/' + versao;

        return this.http.delete(url, {headers: {'Content-Type': 'application/json; charset=utf-8'}});
    }

    public alterarEstadoInstalacaoProduto(codigo: number, versao: number, operacao: string, mensagem: string): Observable<any> {
        let url = this.globalService.getConfiguracao().api_catalogo + '/instalacaoProduto/' + operacao + '/' + codigo + '/' + versao;
        let data = JSON.stringify({'mensagemAtualizacao': mensagem});

        return this.http.post(url, data, {headers: {'Content-Type': 'application/json; charset=utf-8'}});
    }

    public vinculacaoClienteInstalacaoProduto(codigoInstalacao: number, versaoInstalacao: number, cliente: Cliente): Observable<any> {
        let url = this.globalService.getConfiguracao().api_catalogo + '/instalacaoProduto/' + codigoInstalacao + '/' + versaoInstalacao + '/vinculacaoCliente';
        let data = JSON.stringify(
            {
                'acao': 'vincular',
                'cliente': cliente
            }
        );

        return this.http.post(url, data, {headers: {'Content-Type': 'application/json; charset=utf-8'}})
            .map(response => response);
    }

    public criaEditaServico(codigo: number, versao: number, servico: Servico): Observable<any> {
        let url = this.globalService.getConfiguracao().api_catalogo + '/servico/' + codigo + '/' + versao;
        let data = JSON.stringify(servico);

        return this.http.put(url, data, {headers: {'Content-Type': 'application/json; charset=utf-8'}})
            .map(response => response);
    }

    public alterarEstadoServico(codigo: number, versao: number, operacao: string, mensagem: string): Observable<any> {
        let url = this.globalService.getConfiguracao().api_catalogo + '/servico/' + operacao + '/' + codigo + '/' + versao;
        let data = JSON.stringify({'mensagemAtualizacao': mensagem});

        return this.http.post(url, data, {headers: {'Content-Type': 'application/json; charset=utf-8'}})
            .map(response => response);
    }

    public alterarEstadoOperacao(codigo: number, versao: number, operacao: string, mensagem: string): Observable<any> {
        let url = this.globalService.getConfiguracao().api_catalogo + '/operacao/' + operacao + '/' + codigo + '/' + versao;
        let data = JSON.stringify({'mensagemAtualizacao': mensagem});

        return this.http.post(url, data, {headers: {'Content-Type': 'application/json; charset=utf-8'}})
            .map(response => response);
    }

    public removeServico(codigo: number, versao: number): Observable<any> {
        let url = this.globalService.getConfiguracao().api_catalogo + '/servico/deleta' + '/' + codigo + '/' + versao;

        return this.http.delete(url, {headers: {'Content-Type': 'application/json; charset=utf-8'}})
            .map(response => response);
    }

    public operacaoLayout(codigo: number, versao: number, operacao: string, mensagem: string): Observable<any> {
        let url = this.globalService.getConfiguracao().api_catalogo + '/layout/' + operacao + '/' + codigo + '/' + versao;
        let data = JSON.stringify({'mensagemAtualizacao': mensagem});

        return this.http.post(url, data, {headers: {'Content-Type': 'application/json; charset=utf-8'}})
            .map(response => response);
    }

    public removeOperacao(codigo: number, versao: number): Observable<any> {
        let url = this.globalService.getConfiguracao().api_catalogo + '/operacao/deleta' + '/' + codigo + '/' + versao;

        return this.http.delete(url, {headers: {'Content-Type': 'application/json; charset=utf-8'}})
            .map(response => response);
    }

    public alteraSubfluxoFta(codigo: number, versao: number, subfluxo: string): Observable<any> {
        let url = this.globalService.getConfiguracao().api_catalogo + '/fta/' + codigo + '/' + versao + '/alteraSubfluxo';
        let data = JSON.stringify({'novoSubfluxoVigente': subfluxo});

        return this.http.post(url, data, {headers: {'Content-Type': 'application/json; charset=utf-8'}})
            .map(response => response);
    }

    public aprovaArtefatoFta(codigo: number, versao: number, tipo: string, justificativa: string): Observable<any> {
        let url = this.globalService.getConfiguracao().api_catalogo + '/' + tipo + '/aprova/' + codigo + '/' + versao;
        let data = JSON.stringify({'mensagemAtualizacao': justificativa});

        return this.http.post(url, data, {headers: {'Content-Type': 'application/json; charset=utf-8'}})
            .map(response => response);
    }

    public ativaDesativaArtefatoFta(codigo: number, versao: number, tipo: string, operacao: string, msgAtualizacao: string): Observable<any> {
        let url = this.globalService.getConfiguracao().api_catalogo + '/' + tipo + '/' + operacao + '/' + codigo + '/' + versao;
        let data = JSON.stringify({'mensagemAtualizacao': msgAtualizacao});

        return this.http.post(url, data, {headers: {'Content-Type': 'application/json; charset=utf-8'}})
            .map(response => response);
    }

    public despacharArtefatoFta(codigo: number, versao: number, tipo: string, justificativa: string): Observable<any> {
        let url = this.globalService.getConfiguracao().api_catalogo + '/' + tipo + '/despacha/' + codigo + '/' + versao;
        let data = JSON.stringify({'mensagemAtualizacao': justificativa});

        return this.http.post(url, data, {headers: {'Content-Type': 'application/json; charset=utf-8'}})
            .map(response => response);
    }

    public deletaArtefatoFta(codigo: number, versao: number, tipo: string, justificativa: string): Observable<any> {
        let url = this.globalService.getConfiguracao().api_catalogo + '/' + tipo + '/deleta/' + codigo + '/' + versao;

        return this.http.delete(url, {headers: {'Content-Type': 'application/json; charset=utf-8'}})
            .map(response => response);
    }

    public removeLayout(codigo: number, versao: number): Observable<any> {
        let url = this.globalService.getConfiguracao().api_catalogo + '/layout/deleta' + '/' + codigo + '/' + versao;

        return this.http.delete(url, {headers: {'Content-Type': 'application/json; charset=utf-8'}})
            .map(response => response);
    }

    public alterarEstadoFTA(codigo: number, versao: number, operacao: string, mensagem: string): Observable<any> {
        let url = this.globalService.getConfiguracao().api_catalogo + '/fta/' + operacao + '/' + codigo + '/' + versao;
        let data = JSON.stringify({'mensagemAtualizacao': mensagem});

        return this.http.post(url, data, {headers: {'Content-Type': 'application/json; charset=utf-8'}})
            .map(response => response);
    }

    public verificarExistenciaFta(fta: Number): Observable<any> {

        let url = this.globalService.getConfiguracao().api_catalogo + '/fta/filtra/v2';
        let data = JSON.stringify({

            'filtros': [
                {
                    'filtroFta': {
                        'fta': fta
                    }
                }
            ]
        });


        return this.http.post(url, data, {headers: {'Content-Type': 'application/json; charset=utf-8'}})
            .map(response => response);

    }

}



// WEBPACK FOOTER //
// ./src/service/api/catalogo.api.ts